export default "__VITE_ASSET__BCBM3aWI__"